// @flow
import { DevicesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    device: {},
    listaDevices: [],
    listaPlayers: [],
    listaInteractives: [],
    loading: false,
    error: false,
    formSubmited: false
};

type DevicesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { device?: {} | null, listaDevices?: [] | null, listaPlayers?: [] | null, listaInteractives?: [] | null, loading?: boolean, +value ?: boolean };

const Devices = (state: State = INIT_STATE, action: DevicesAction): any => {
    switch (action.type) {
        case DevicesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DevicesActionTypes.GET_DEVICE: {
                    return {
                        ...state,
                        device: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DevicesActionTypes.LIST_DEVICES: {
                    return {
                        ...state,
                        listaDevices: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DevicesActionTypes.ADD_DEVICE: {
                    return {
                        ...state,
                        device: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesActionTypes.UPDATE_DEVICE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesActionTypes.DELETE_DEVICE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesActionTypes.LIST_PLAYERS: {
                    return {
                        ...state,
                        listaPlayers: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DevicesActionTypes.LIST_INTERACTIVES: {
                    return {
                        ...state,
                        listaInteractives: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case DevicesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DevicesActionTypes.GET_DEVICE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        device: {},
                        loading: false,
                    };
                }
                case DevicesActionTypes.LIST_DEVICES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaDevices: [],
                        loading: false,
                    };
                }
                case DevicesActionTypes.ADD_DEVICE: {
                    return {
                        ...state,
                        device: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesActionTypes.UPDATE_DEVICE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesActionTypes.DELETE_DEVICE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesActionTypes.LIST_PLAYERS: {
                    return {
                        ...state,
                        listaPlayers: [],
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case DevicesActionTypes.LIST_INTERACTIVES: {
                    return {
                        ...state,
                        listaInteractives: [],
                        error: action.payload.error,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case DevicesActionTypes.GET_DEVICE:
            return { ...state, error: false, loading: true };
        case DevicesActionTypes.LIST_DEVICES:
            return { ...state, error: false, loading: true };
        case DevicesActionTypes.ADD_DEVICE:
            return { ...state, error: false, loading: true };
        case DevicesActionTypes.UPDATE_DEVICE:
            return { ...state, error: false, loading: true };
        case DevicesActionTypes.DELETE_DEVICE:
            return { ...state, error: false, loading: true };
        case DevicesActionTypes.LIST_PLAYERS:
            return { ...state, error: false, loading: true };
        case DevicesActionTypes.LIST_INTERACTIVES:
            return { ...state, error: false, loading: true };
        case DevicesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                device: {},
                listaDevices: [],
                listaPlayers: [],
                listaInteractives: [],
                formSubmited: false,
            };
        default:
            return { ...state };
    }
};

export default Devices;
